import { Component, NgModule, Input, Output, EventEmitter, OnInit, OnChanges, OnDestroy, AfterViewInit, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthService, ScreenService } from '../../services';
import { UserPanelModule } from '../user-panel/user-panel.component';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxToolbarModule } from 'devextreme-angular/ui/toolbar';
import { Router, RouterModule } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { CoreModule } from 'src/app/core/core.module';
import { throwError } from 'rxjs';
import { CommonPreLoadedService } from 'src/app/core/services/common/common-pre-loaded.service';
import { catchError } from 'rxjs/operators';
import { BaseRequestService } from '../../services/base-request.service';
import { APIConfing } from '../../services/apiconfing.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})

export class HeaderComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @Output() menuToggle = new EventEmitter<boolean>();
  @Input() menuToggleEnabled = false;
  @Input() title: string;
  @Input() isAuthorized: boolean;
  @Input() showSideBar: boolean;
  cTitle: string;
  getAuthInfo: any;
  userMenuItems = [/* {
    text: 'Profile',
    icon: 'user'
  },  */ {
      text: 'Change Password',
      icon: 'assets/Web Icon/Black/Change Password.png',
      onClick: this.fnResetPassword.bind(this)
    }, {
      text: 'Logout',
      icon: 'assets/Web Icon/Black/Log Out.png',
      onClick: this.fnLogOut.bind(this)
    }];
  getIMG: any;
  getIMG1: any;
  getTitle: any = '';
  isHomeEnabled = true;
  isESSHelpFileURL = false;
  isWPHelpFileURL = false;
  // notificationArr: any = [];
  notificationArr: any = [];
  rid: any;
  note: any;
  helpFileArr: any = [
    { title: 'Attendance Correction', link: '/assets/hel_files/Attendance_Correction.mp4' },
    { title: 'How To Apply Leave', link: '/assets/hel_files/How_To_Apply_Leave.mp4' },
    { title: 'Login Page', link: '/assets/hel_files/Login_Page.mp4' },
    { title: 'Reimbursment', link: '/assets/hel_files/Reimbursment.mp4' },
  ];
  isLogoClickable: boolean = true;


  constructor(private authService: AuthService, private router: Router,
    private _ngZone: NgZone, public baseRequest: BaseRequestService, private toastrService: ToastrService,
    private commonAPI: CommonPreLoadedService, public common: CommonService,
    private screen: ScreenService) {
    this.filterDrawer();
    this.screen.changed.subscribe((obj) => {
      this.filterDrawer();
    });
    this.commonAPI.watchTitle().subscribe(title => {
      if (title) {
        this.getTitle = title;
      }
    });
    this.commonAPI.watchAuthInfo().subscribe(data => {
      if (data) {
        this.getAuthInfo = data;
        if (this.getAuthInfo && this.getAuthInfo.length && ((this.getAuthInfo[0].isOfferReleased == 1 || this.getAuthInfo[0].isHRLetterReleased == 1 || this.getAuthInfo[0].isAssetLetterReleased == 1) || this.getAuthInfo[0].restrictEmpLogin || this.router.url.includes('/Public/Onboarding'))) {
          this.isLogoClickable = false;
        } else {
          this.isLogoClickable = true;
        }
      }
    });
    if (this.isAuthorized) {
      this.getAuthInfo = this.common.fnGetAuthInfo();
      this.isESSHelpFileURL = this.getAuthInfo[0].cssOptions.essHelpFileURL ? true : false;
      this.isWPHelpFileURL = this.getAuthInfo[0].wpOptions.obHelpFileURL ? true : false;
      if (this.getAuthInfo[0].customerLogo !== '') {
        this.getIMG = this.getAuthInfo[0].customerLogo;
      } else {
        this.getIMG = '/assets/img/StaffingGo.png';
      }
    } else {
      this.getIMG1 = '/assets/img/StaffingGo.png'
    }

  }

  ngOnInit() {
    if (this.isAuthorized) {
      this.getAuthInfo = this.common.fnGetAuthInfo();
      this.isESSHelpFileURL = this.getAuthInfo[0].cssOptions.essHelpFileURL ? true : false;
      this.isWPHelpFileURL = this.getAuthInfo[0].wpOptions.obHelpFileURL ? true : false;
      if (this.getAuthInfo[0].customerLogo !== '') {
        this.getIMG = this.getAuthInfo[0].customerLogo;
      } else {
        this.getIMG = '/assets/img/StaffingGo.png';
      }
      this.fnGetNotificationDetails();

    } else {
      this.getIMG1 = '/assets/img/StaffingGo.png'
    }
    if (this.getAuthInfo && this.getAuthInfo[0] && ((this.getAuthInfo[0].isOfferReleased == 1 || this.getAuthInfo[0].isHRLetterReleased == 1 || this.getAuthInfo[0].isAssetLetterReleased == 1) || this.getAuthInfo[0].restrictEmpLogin || this.router.url.includes('/Public/Onboarding'))) {
      this.isLogoClickable = false;
    } else {
      this.isLogoClickable = true;
    }

  }

  ngOnChanges() {

  }

  ngOnDestroy() {
    this.isLogoClickable = true;
  }

  ngAfterViewInit() {
    this.toggleMenu();
  }

  isFullScreeen: boolean = true;
  filterDrawer() {
    const isXSmall = this.screen.sizes['screen-x-small'];
    const isSmall = this.screen.sizes['screen-small'];
    const isMedium = this.screen.sizes['screen-medium'];
    const isLarge = this.screen.sizes['screen-large'];
    if (isXSmall || isSmall) {
      this.isFullScreeen = false;
    } else if (isMedium || isLarge) {
      this.isFullScreeen = true;
    } else {
      this.isFullScreeen = true;
    }
  }

  fnOpenESSHelpFile(item) {
    window.open(item.link, '_target');
  }
  fnOpenWPHelpFile() {
    window.open(this.getAuthInfo[0].wpOptions.obHelpFileURL, '_target');
  }

  toggleMenu = () => {
    // this.menuToggle.emit();
    var element = document.getElementById("mainContainer");
    if (element && element.classList)
      element.classList.toggle("ess-body");
  }

  fnLogOut() {
    this.authService.logout();
  }

  fnResetPassword() {
    this.router.navigate(['/Change-Password']);
  }

  fnNavigateToNotification() {
    this.router.navigate(['/Common-Notifications']);
  }

  fnStatusUpdate(data) {
    const obj = {
      "rid": data.rid
    }
    this.baseRequest.fnpost('/CSS/Consultant/ESSUpdateNotificationStatus', obj)
      .pipe(catchError(err => throwError(err)))
      .subscribe((objRESP: any) => {
        if (objRESP && objRESP.status && objRESP.code === this.baseRequest.status.success) {
          // this.toastrService.success("Sucessfully Updated", "success");
          this.fnGetNotificationDetails();
          if (data.msgType == 1) {
            this.router.navigate(['/Leave-Approvals']);
          } else {
            this.router.navigate(['/Common-Notifications']);
          }
        } else if (objRESP.code === 'E002') {
          this.toastrService.error(APIConfing.data.E002);
          if (data.msgType == 1) {
            this.router.navigate(['/Leave-Approvals']);
          } else {
            this.router.navigate(['/Common-Notifications']);
          }
        } else if (objRESP && objRESP.code === this.baseRequest.duplicate.duplicate) {
          if (data.msgType == 1) {
            this.router.navigate(['/Leave-Approvals']);
          } else {
            this.router.navigate(['/Common-Notifications']);
          }
        }
        else {
          if (data.msgType == 1) {
            this.router.navigate(['/Leave-Approvals']);
          } else {
            this.router.navigate(['/Common-Notifications']);
          }
        }
      },
        error => {
          if (error && error.error.message) {
            this.toastrService.error(error.error.message, 'Error!');
          }
          else {
            this.toastrService.error('Something went wrong.', 'Error!');
          }
        });
  }



  notificationArrLength = 0;
  notificationArrLen: any;
  fnGetNotificationDetails() {
    //this.spinner.show(this.AnnouncementsSpinner);
    const getDashboard: any = {

    };
    this.baseRequest.fnpost('/CSS/Consultant/ESSGetNotificationStatus', getDashboard)
      .pipe(catchError(err => throwError(err)))
      .subscribe((objRESP: any) => {
        // this.spinner.hide(this.AnnouncementsSpinner);
        if (objRESP && objRESP.code === this.baseRequest.status.success) {
          this.notificationArr = objRESP.dataObject;
          this.notificationArrLen = objRESP.dataObject.filter((item) => item.readStatus === 0);
          this.notificationArrLength = this.notificationArrLen.length;
        } else if (objRESP.code === 'E002') {
          this.toastrService.error(APIConfing.data.E002);
        } else if (objRESP.code === 'E001') {
          this.toastrService.error(objRESP.message, 'Error');
          this.notificationArr = [];
          this.notificationArrLen = [];
        } else if (objRESP.code === this.baseRequest.warning.code) {
          this.toastrService.warning(objRESP.message, 'Details');
          this.notificationArr = [];
          this.notificationArrLen = [];
        } else {
          this.notificationArr = [];
          this.notificationArrLen = [];
          // this.spinner.hide(this.AnnouncementsSpinner);
        }
      }, err => this.toastrService.error(APIConfing.data.E002, 'Error'));
  }
  fnGetTitleByType(type) {
    switch (type) {
      case 1:
        return 'Leave Approvals';
        break;
      case 0:
        return 'Leave Approvals';
        break;
      case 2:
        return 'Leave Approvals';
        break;
      case 3:
        return 'Leave Approvals';
        break;

      default:
        break;
    }
  } fnGetRouteByType(type) {
    switch (type) {
      case 1:
        this.router.navigate(['/Leave-Approvals']);
        break;
      case 0:
        this.router.navigate(['']);
        break;
      case 2:
        this.router.navigate(['']);
        break;
      case 3:
        this.router.navigate(['']);
        break;

      default:
        break;
    }
  }
  groupByArray(xs, key) {
    return xs.reduce((rv, x) => {
      let v = key instanceof Function ? key(x) : x[key];
      let el = rv.find((r) => r && r.key === v);
      if (el) {
        el.values.push(x);
      } else {
        rv.push({ key: v, values: [x] });
      }
      return rv;
    }, []);
  }




}

@NgModule({
  imports: [
    CommonModule,
    DxButtonModule,
    UserPanelModule,
    DxToolbarModule,
    CoreModule,
    RouterModule
  ],
  declarations: [HeaderComponent],
  exports: [HeaderComponent]
})
export class HeaderModule { }
